import { isNullUndefinedOrEmptyString } from './object'

function encodeValue(value: unknown) {
  if (value instanceof Date) {
    const year = value.getFullYear()
    const month = `0${value.getMonth()}`.slice(-2)
    const day = `0${value.getDate()}`.slice(-2)
    const hours = `0${value.getHours()}`.slice(-2)
    const minutes = `0${value.getMinutes()}`.slice(-2)
    const seconds = `0${value.getSeconds()}`.slice(-2)
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
  } else {
    return value
  }
}

export const redirectExterne = (url: string, target?: string) => {
  const a = document.createElement('a')
  try {
    a.href = url
    a.target = target ?? '_blank'
    document.body.appendChild(a)
    a.click()
  } finally {
    setTimeout(() => a.remove(), 100)
  }
}

export function urlEncodeQuery(queryParams: any): string {
  const result = Object.keys(queryParams)
    .map((key) => {
      const value = queryParams[key]
      if (isNullUndefinedOrEmptyString(value)) return ''
      if (Array.isArray(value)) {
        return value
          .filter((item) => !isNullUndefinedOrEmptyString(item))
          .map((item) => `${key}=${encodeValue(item)}`)
          .join('&')
      } else {
        return `${key}=${encodeValue(value)}`
      }
    })
    .filter((item) => !!item)
    .join('&')

  if (result) return `?${result}`
  else return ''
}
